import _ from "lodash"

export default function (payload, findFn, userId) {
  let course = payload.courseId ? findFn("course", payload.courseId) : null
  let planbook = course ? findFn("planbook", _.get(course, "relationships.planbook.data.id")) : null
  let user = findFn("user", userId)

  return {
    course,
    planbook,
    user,
  }
}
